import React, { useContext } from "react";
import sld from "../../images/sld/Rectangle.svg";
import Ecc from "../../components/ISLANDABLE/Ecc";
import Busbar from "../../components/ISLANDABLE/Busbar";
import Utility from "../../components/ISLANDABLE/Utility";
import Genset from "../../components/ISLANDABLE/Genset";
import Battery from "../../components/ISLANDABLE/Battery";
import PV1 from "../../components/ISLANDABLE/PV1";
import PV2 from "../../components/ISLANDABLE/PV2";
import PV3 from "../../components/ISLANDABLE/PV3";
import CHP from "../../components/ISLANDABLE/CHP";
import Load from "../../components/ISLANDABLE/Load";
import Ev from "../../components/ISLANDABLE/Ev";
import Linebar from "../../components/GRIDCONNECTED/Linebar";
import embLabels from "../../config/emb-labels-en.json";

import { DesignAssetContext } from "../CustomHooks/ContextApi"; 
import { uniqueId } from "lodash";
import LoadPvBess from "../../components/GensetPvBess/LoadPvBess";

const IslandableSLD = () => {
  const {
    CBAssetList,
    CBEVList,
    CBLoadList,
    sldLoadCompleted,
    projectKind,
    switchboardType,
    coordinates,
    count,
    loadSide
  } = useContext(DesignAssetContext);
  const areAllConfigured = () =>{
    return CBLoadList.every(item => item.uiData.configured);
  }
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
    >
      <svg viewBox="0 0 1400 800">
        <g>
          <svg x="0" y="0" viewBox="0 0 1400 800">
            <g id="grid">
              <svg>
                <image href={sld} x="0" y="0" />
              </svg>
            </g>
            <svg x="0" y="0" viewBox="0 0 1400 800">
            <g
              id="components-sld"
              style={sldLoadCompleted ? {} : { display: "none" }}
            >
              <Ecc />
              <Busbar secondBusbar={true} />
              {projectKind?.isMgaasIecIsland &&
                switchboardType === embLabels?.EXISTING_SWITCHBOARD && (
                  <Linebar key={uniqueId()} />
                )}
              <Utility />
              {CBAssetList[1].uiData.status && <Genset />}
              {CBAssetList[2].uiData.status && <Battery />}
              {CBAssetList[3].uiData.status && <PV1 />}
              {CBAssetList[4].uiData.status && <PV2 />}
              {CBAssetList[5].uiData.status && <PV3 />}
              {CBAssetList[6].uiData.status && <CHP />}
              <svg
                id="load pointer"
                x={
                  count?.evCount === 1 && switchboardType === embLabels?.EXISTING_SWITCHBOARD
                    ? count?.derCount ===6
                    ? loadSide ==="LOAD_SIDE"?"50":"200"
                    : count?.derCount ===5
                    ?loadSide ==="LOAD_SIDE"?"80":"165"
                    :count?.derCount ===4
                    ?loadSide ==="LOAD_SIDE"?"130":"180"
                    :loadSide ==="LOAD_SIDE"?"125":"155"
                    : switchboardType === embLabels?.EXISTING_SWITCHBOARD ? "120"
                    
                    :  count?.evCount === 1?
                    count?.derCount ===6
                    ?-100
                    : count?.derCount ===5
                    ?-60
                    :count?.derCount ===4
                    ?-60
                    :-50:"0"
                }
                y="0"
              >
                {/* {CBLoadList?.map((loadData, key) => (
                  <Load
                    key={loadData.uiData.xAxis}
                    load={loadData.uiData}
                    loadName={loadData.configData.name}
                    loadCbName={loadData.cbConfigData.name}
                    index={key}
                    powerMeterData={loadData.powerMeterData}
                  />
                ))} */}
                {CBLoadList.length > 0 &&
                              <LoadPvBess
                              loadLength = {count}
                                configured = {areAllConfigured()}
                              />
                            }
              </svg>
             <svg x={
              count?.derCount === 6 
              ?switchboardType === embLabels?.EXISTING_SWITCHBOARD?200:300
              :count?.derCount === 5
              ?switchboardType === embLabels?.EXISTING_SWITCHBOARD?155:260
              :count?.derCount === 4
              ?switchboardType === embLabels?.EXISTING_SWITCHBOARD?90:200
              :count?.derCount === 3
              ? count?.evCount === 1?embLabels?.EXISTING_SWITCHBOARD?80:135:70
              :0
             } y="0">
              {CBEVList.map(
                (cbData, key) =>
                  cbData.uiData.status && (
                    <Ev key={cbData.configData.name} index={key} />
                  )
              )}
              </svg>
            </g>
            </svg>
          </svg>
        </g>
      </svg>
    </div>
  );
};

export default IslandableSLD;
